var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"phone-icon",attrs:{"src":"https://xiaomai-image.oss-cn-hangzhou.aliyuncs.com/1571312901291.png?x-oss-process=image/resize,w_300,limit_0","alt":"phone-icon"},on:{"click":_vm.handleClickPhone}})}
var staticRenderFns = []

export { render, staticRenderFns }